import React from 'react';
import { PageHeader } from '../components/layout/PageHeader';
import { ExperienceTimeline } from '../components/sections/ExperienceTimeline';
export function ExperiencesPage() {
  return <div data-id="element-253" data-mp="1abzz93hemtwa">
      <PageHeader eyebrow="Experiences" title="Executive Career Summary" description="Chronological executive career summary at Ameren and early-stage ventures." data-id="element-254" data-mp="1abq99fwd0mql" />
      <section className="bg-white pb-20 lg:pb-28" data-id="element-255" data-mp="10ev7mo4si683">
        <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-256" data-mp="10ger0nlqsxe3">
          <ExperienceTimeline data-id="element-257" data-mp="vmkaft1foyj8" />
        </div>
      </section>
    </div>;
}